import script from "./DrUniversityHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrUniversityHome.vue?vue&type=script&setup=true&lang=ts"

import "./DrUniversityHome.vue?vue&type=style&index=0&id=68ec8d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ec8d06"]])

export default __exports__